import { IDIOMAS, ponerIdioma, tx, useIdioma, type Idioma } from '../i18n';

/** Cada idioma se nombra en sí mismo: quien no entiende el actual igual encuentra el suyo. */
const NOMBRE: Record<Idioma, string> = { en: 'English', es: 'Español' };

/**
 * EN / ES en la barra de arriba. El idioma se recuerda en este navegador: el panel es
 * interno y cada quien entra desde el suyo.
 */
export function SelectorIdioma() {
  const actual = useIdioma();
  return (
    <div className="seg idioma" role="group" aria-label={tx.marco.idioma}>
      {IDIOMAS.map((i) => (
        <button key={i} type="button" lang={i} title={NOMBRE[i]} aria-label={NOMBRE[i]} aria-pressed={actual === i} onClick={() => ponerIdioma(i)}>
          {i.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
